import React from 'react'
import { Row, Col, Table } from 'react-bootstrap'

type Procedure = {
  date: string
  code: string
  tooth: string
  surface: string
  description: string
  provider: string
  submittedFee: string
  fee: string
  estimatedInsurance: string
  insurancePaymentPosted: string
  insuranceOverpaid: string
  insuranceAllocated: string
  overDiscount: string
  writeOffPosted: string
  writeOffOver: string
  writeOffAllocated: string
  patientPaid: string
  otherInsurancePaid: string
  reasonCode: string
}

type ProceduresInThisClaimProps = {
  procedures: Procedure[]
}

const ProceduresInThisClaim = ({
  procedures,
}: ProceduresInThisClaimProps): React.ReactElement => {
  return (
    <Row className="mb-2">
      <Col md={12}>
        <div className="bg-custom3 text-dark ps-3 p-1 rounded-top">
          <span className="fw-bold fs-5">Procedures In This Claim</span>
        </div>
        <Table bordered striped>
          <thead>
            <tr>
              <th>Date</th>
              <th>Code</th>
              <th>Th</th>
              <th>Surf</th>
              <th>Descr</th>
              <th>Prdr</th>
              <th>Submitted Fee</th>
              <th>Fee</th>
              <th>Est. Ins</th>
              <th>Ins Pay Posted</th>
              <th>Ins Over Paid</th>
              <th>Ins Allocated</th>
              <th>Over Dis.</th>
              <th>Write-Off Posted</th>
              <th>Write-Off Over</th>
              <th>Write-Off Alloc</th>
              <th>Pat Paid</th>
              <th>Other Ins Paid</th>
              <th>Reason Code</th>
            </tr>
          </thead>
          <tbody>
            {procedures.map((procedure, index) => (
              <tr key={index}>
                <td>{procedure.date}</td>
                <td>{procedure.code}</td>
                <td>{procedure.tooth}</td>
                <td>{procedure.surface}</td>
                <td>{procedure.description}</td>
                <td>{procedure.provider}</td>
                <td>{procedure.submittedFee}</td>
                <td>{procedure.fee}</td>
                <td>{procedure.estimatedInsurance}</td>
                <td>{procedure.insurancePaymentPosted}</td>
                <td>{procedure.insuranceOverpaid}</td>
                <td>{procedure.insuranceAllocated}</td>
                <td>{procedure.overDiscount}</td>
                <td>{procedure.writeOffPosted}</td>
                <td>{procedure.writeOffOver}</td>
                <td>{procedure.writeOffAllocated}</td>
                <td>{procedure.patientPaid}</td>
                <td>{procedure.otherInsurancePaid}</td>
                <td>{procedure.reasonCode}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={5}></th>
              <th>Total</th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc + parseFloat(procedure.submittedFee.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc + parseFloat(procedure.fee.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc +
                      parseFloat(procedure.estimatedInsurance.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc +
                      parseFloat(
                        procedure.insurancePaymentPosted.replace('$', ''),
                      ),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc +
                      parseFloat(procedure.insuranceOverpaid.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc +
                      parseFloat(procedure.insuranceAllocated.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>-</th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc +
                      parseFloat(procedure.writeOffPosted.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc + parseFloat(procedure.writeOffOver.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc +
                      parseFloat(procedure.writeOffAllocated.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc + parseFloat(procedure.patientPaid.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th>
                {procedures
                  .reduce(
                    (acc, procedure) =>
                      acc +
                      parseFloat(procedure.otherInsurancePaid.replace('$', '')),
                    0,
                  )
                  .toFixed(2)}
              </th>
              <th></th>
            </tr>
          </tfoot>
        </Table>
      </Col>
    </Row>
  )
}

export default ProceduresInThisClaim
